<template>
    <div>
        <el-row>
            <el-col :span="24" class="text-md-left my-8">
                <span class="text-bold">ประวัติการทำรายการ</span>
            </el-col>
            <el-col :sm="24">
                <el-table
                    :data="historyList"
                    ref="customerTable"
                    stripe
                    :header-cell-style="{'background-color': 'black', 'color': 'white'}"
                    style="width: 100%"
                >
                    <el-table-column label="วันที่สร้าง" width="200">
                        <div slot-scope="scope">
                            {{scope.row.createdAt | dayjs('format', ('DD/MM/YYYY HH:mm:ss'))}}
                        </div>
                    </el-table-column>
                    <el-table-column label="ชื่อแพ็กเกจ" width="300">
                        <div slot-scope="scope">
                            <div v-if="scope.row.subscriptionName">{{scope.row.subscriptionName}} Package แบบ{{scope.row.subscriptionPlan ? convertEnumSubscription(scope.row.subscriptionPlan) : ''}}</div>
                            <div v-else>-</div>
                        </div>
                    </el-table-column>
                    <el-table-column label="ราคา (บาท)" width="130">
                        <div slot-scope="scope">
                            {{numberWithCommas(scope.row.netPriceAmount)}}
                        </div>
                    </el-table-column>
                    <el-table-column label="สร้างโดย" width="220">
                        <div slot-scope="scope">
                            <div v-if="scope.row.createdBy">{{scope.row.createdBy}}</div>
                            <div v-else>-</div>
                        </div>
                    </el-table-column>
                    <el-table-column label="จัดการ" fixed="right">
                        <template class="text-md-center" slot-scope="scope">
                            <el-button :key="scope.$index" size="small" icon="el-icon-user" type="primary" plain @click="openPaymentDetailDialog(scope.row)"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
            <el-col style="margin-top:10px;">
                <el-pagination
                    @size-change="changeLimitPage"
                    @current-change="changeCurrentPage"
                    :current-page.sync="pagination.currentPage"
                    :page-sizes="pagination.pageSizes"
                    :page-size="10"
                    layout="prev, pager, next, sizes"
                    :total="pagination.allPage * pagination.limit">
                </el-pagination>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import fgApi from '@/services/fillgoods'
import numberWithCommas from '@/mixins/formatDigitMixin'
import { SUBSCRIPTION_TYPE_TH as enumSubscriptionTypeTh } from '@/constant/subscription.js'
export default {
    name: 'paymentHistoryTable',
    mixins: [numberWithCommas],
    props: {
        detail: {
            type: Object,
            default: null
        }
    },
    data () {
        return {
            paymentDetail: {
                dialog: false
            },
            historyList: [],
            originalHistoryList: [],
            pagination: {
                limit: 10,
                offset: 0,
                allPage: 1,
                currentPage: 1,
                pageSizes: [10, 20, 50, 100, 200]
            }
        }
    },
    watch: {
        'detail.userId': {
            handler (val) {
                if (val) {
                    this.getHistoryList()
                }
            },
            immediate: true
        },
        'detail.fetchHistoryList': {
            handler (val) {
                if (val) {
                    this.getHistoryList()
                }
            },
            immediate: true
        }
    },
    methods: {
        async getHistoryList () {
            let param = {
                userId: this.detail.userId
            }
            try {
                let res = await fgApi.payment.getPaymentHistory(param)
                if (res.success) {
                    this.originalHistoryList = res.data.result
                    this.changeDataInArray()
                }
            } catch (error) {
                console.log(error)
            }
        },
        changeDataInArray () {
            if (this.pagination.offset === 0) {
                this.historyList = this.originalHistoryList.slice(0, this.pagination.limit)
            } else {
                this.historyList = this.originalHistoryList.slice(this.pagination.offset, (this.pagination.offset + this.pagination.limit))
            }
            this.pagination.allPage = Math.ceil(this.originalHistoryList.length / this.pagination.limit)
            if (this.historyList[0]) {
                this.$emit('historyDetail', this.historyList[0])
                this.detail.fetchHistoryList = false
            } else {
                this.$emit('historyDetail', [])
                this.detail.fetchHistoryList = false
            }
        },
        changeLimitPage (val) {
            this.pagination.limit = val
            this.changeDataInArray()
        },
        changeCurrentPage () {
            this.pagination.offset = (this.pagination.currentPage * this.pagination.limit) - this.pagination.limit
            this.changeDataInArray()
        },
        convertEnumSubscription (code) {
            return enumSubscriptionTypeTh[code]
        },
        openPaymentDetailDialog (data) {
            this.$emit('onClickPaymentDetailDialog', { dialog: true, isCreate: false, detail: data, userCode: this.detail.userCode })
        },
        closeDialog () {
            this.paymentDetail.dialog = !this.paymentDetail.dialog
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
